export default __webpack_public_path__ + "static/media/ID_SCHOOL_CHARLIE.f7c12373.jpg";